import { axios } from 'lib/axios';
import { queryClient } from 'lib/react-query';
import { useNotificationStore } from 'stores/notifications';
import PropTypes from 'prop-types';
import { useMutation } from 'react-query';

export const deleteLimit = ({ id }) => {
  return axios.delete(`/paymentOptionsLimit/${id}`);
};

deleteLimit.propTypes = {
  id: PropTypes.string.isRequired,
};

export const useDeleteLimit = ({ config } = {}) => {
  const { addNotification } = useNotificationStore();

  return useMutation({
    onMutate: async (deletedLimit) => {
      await queryClient.cancelQueries('limits');

      const previousLimits = queryClient.getQueryData('limits');

      queryClient.setQueryData(
        'limits',
        previousLimits?.filter((limit) => limit.id !== deletedLimit.id)
      );

      return { previousLimits };
    },
    onError: (_, __, context) => {
      if (context?.previousLimits) {
        queryClient.setQueryData('limits', context.previousLimits);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries('limits');
      addNotification({
        type: 'success',
        title: 'Limit Deleted',
      });
    },
    ...config,
    mutationFn: deleteLimit,
  });
};
